<template>
  <div class="col-lg-2 col-md-4">
    <div class="footer-title">
      <h5>
        {{ _T('Business') }}
        <span class="according-menu">
          <svg width="12" height="6" fill="none">
            <use xlink:href="#downArrow" />
          </svg>
        </span>
      </h5>
    </div>
    <ul class="footer-content" v-if="!domainBasedBrand">
      <li>
        <router-link :to="{ name: 'partner_with_us' }">{{
          _T('Partner with us')
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand']),
  },
}
</script>
